import React from 'react';
import { BarChart3, MapPin, Bell, Layers } from 'lucide-react';

const PlatformSection = () => {
  const features = [
    {
      icon: BarChart3,
      title: 'Analytics & Insights',
      description: 'Track departures, arrivals, and asset rotation patterns'
    },
    {
      icon: MapPin,
      title: 'Site-to-Site Visibility',
      description: 'Monitor assets moving between your facilities in real-time'
    },
    {
      icon: Bell,
      title: 'Alerts & Notifications',
      description: 'Get instant notifications for missing assets or delays'
    },
    {
      icon: Layers,
      title: 'Multi-Site Management',
      description: 'Manage all locations from a single dashboard'
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Platform & Dashboard
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Powerful insights and control at your fingertips
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <img 
              src="https://images.pexels.com/photos/3912977/pexels-photo-3912977.jpeg"
              alt="Dashboard interface"
              className="rounded-2xl shadow-2xl"
            />
          </div>
          
          <div className="space-y-6">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div key={index} className="flex items-start gap-4 bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-colors duration-300">
                  <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-red-500 to-red-600 flex items-center justify-center flex-shrink-0">
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
                    <p className="text-gray-300">{feature.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Additional Features */}
        <div className="grid md:grid-cols-3 gap-8 mt-16">
          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
            <h4 className="text-lg font-bold mb-3">API Integration</h4>
            <p className="text-gray-300 text-sm">REST API for seamless integration with your ERP, WMS, and TMS systems</p>
          </div>
          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
            <h4 className="text-lg font-bold mb-3">Message Counters</h4>
            <p className="text-gray-300 text-sm">Track communication frequency and network health across all sites</p>
          </div>
          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
            <h4 className="text-lg font-bold mb-3">Flow Diagrams</h4>
            <p className="text-gray-300 text-sm">Visualize asset movements and identify bottlenecks instantly</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlatformSection;
